export { default } from './extractEventHandlers';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/extractEventHandlers/index.js
// module id = 232
// module chunks = 25